import React, { useEffect } from 'react';
import { BonusesHeroSection } from './components/BonusesHeroSection';
import { PainSection } from './components/PainSection';
import { TransitionSection } from './components/TransitionSection';
import { Mapa5RSection } from './components/Mapa5RSection';
import { BonusOneSection } from './components/BonusOneSection';
import { BonusTwoSection } from './components/BonusTwoSection';
import { BonusThreeSection } from './components/BonusThreeSection';
import { ValueStackSection } from './components/ValueStackSection';
import { UrgencySection } from './components/UrgencySection';
import { RiskReversalSection } from './components/RiskReversalSection';
import { BonusesFinalCTASection } from './components/BonusesFinalCTASection';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-[#1A1A1A]" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        <BonusesHeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <TransitionSection data-id="element-4" />
        <Mapa5RSection data-id="element-5" />
        <BonusOneSection data-id="element-6" />
        <BonusTwoSection data-id="element-7" />
        <BonusThreeSection data-id="element-8" />
        <ValueStackSection data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <RiskReversalSection data-id="element-11" />
        <BonusesFinalCTASection data-id="element-12" />
      </main>

      <footer className="bg-[#111] text-gray-500 py-8 text-center text-sm" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} Link Academy. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-15">
          Este sitio no es parte de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}